import { service } from 'Services/api/api.service';
import { STAGE } from 'Config';
import { TaxServiceType } from './types';

const BASE_ENDPOINT_URL = 'tax';

const buildType = {
  dev: 'current',
  staging: 'latest',
  prod: 'latest',
};

const TaxService: TaxServiceType = {
  getForms: params =>
    service.get(`${BASE_ENDPOINT_URL}/form`, {
      params: {
        taxYear: params?.taxYear,
        build: STAGE && buildType[STAGE],
      },
    }),
  getSeasons: () => service.get(`${BASE_ENDPOINT_URL}/seasons`),
};

export default TaxService;
